import React, { useEffect } from "react";
import { Sparkles, Zap, Coins, X } from "lucide-react";
import { fireBigConfetti } from "@/lib/confetti";

export function MilestoneModal({ milestone, onClose }) {
  useEffect(() => {
    fireBigConfetti();
  }, []);

  if (!milestone) return null;

  return (
    <div className="fixed inset-0 z-[80] bg-black/75 backdrop-blur-sm flex items-center justify-center p-4" data-testid="milestone-modal">
      <div className="glass-panel rounded-3xl max-w-md w-full p-8 text-center relative border border-amber-400/30 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-[#3B82F6]/10 to-[#8B5CF6]/10" />
        <button onClick={onClose} data-testid="milestone-close-btn" className="absolute top-4 right-4 text-slate-400 hover:text-white z-10">
          <X className="w-5 h-5" />
        </button>
        <div className="relative">
          <div className="w-16 h-16 rounded-2xl bg-amber-400/15 border border-amber-400/30 flex items-center justify-center mx-auto mb-4">
            <Sparkles className="w-8 h-8 text-amber-400" />
          </div>
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-amber-300">Day {milestone.day} Milestone</span>
          <h2 className="font-heading text-2xl sm:text-3xl font-semibold text-white mt-2 mb-3">{milestone.title}</h2>
          <p className="text-sm text-slate-300 mb-6">{milestone.message}</p>
          <div className="flex items-center justify-center gap-4">
            <span className="flex items-center gap-1.5 text-base font-bold text-[#FBBF24]" data-testid="milestone-bonus-xp"><Zap className="w-5 h-5" /> +{milestone.bonus_xp} XP</span>
            <span className="flex items-center gap-1.5 text-base font-bold text-[#FBBF24]" data-testid="milestone-bonus-coins"><Coins className="w-5 h-5" /> +{milestone.bonus_coins} Coins</span>
          </div>
          <button onClick={onClose} data-testid="milestone-continue-btn" className="mt-7 bg-primary hover:bg-primary/90 text-white font-semibold text-sm px-8 py-3 rounded-xl transition-colors">
            Keep Going
          </button>
        </div>
      </div>
    </div>
  );
}
